import type { FC } from "react";

import { cn } from "@/lib/utils";

import type { Tutorial } from "../types";
import { PlayDisc } from "./PlayDisc";

type Props = {
  tutorial: Tutorial;
  className?: string;
};

/** The 16:9 poster with the player's play button, for previews. */
export const TutorialPoster: FC<Props> = ({ tutorial, className }) => (
  <span
    className={cn(
      "relative block aspect-video w-full overflow-hidden bg-black",
      className
    )}
  >
    {tutorial.poster ? (
      <img
        src={tutorial.poster}
        alt=""
        className="absolute inset-0 size-full object-cover"
        loading="lazy"
      />
    ) : null}
    <span className="absolute inset-0 flex items-center justify-center">
      <PlayDisc size="md" />
    </span>
  </span>
);
